// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import { Query } from 'react-apollo'
import { Typography } from '@mui/material'
import { i18n } from '../../index'
import Loader from '../../../common/loader/Loader'
import css from '../incentiveProduct/incentiveProductPage.css'
import ShiftResponsibilityPage from './ShiftResponsibilityPage'
import { fetchChainShiftResponsibilities } from '../../shiftResponsibility/shiftResponsibilityQueries'

function ChainShiftResponsibilityPage() {
  return (
    <div>
      <div className={css.top}>
        <Typography variant='h6'>{i18n.t('admin.shiftResponsibilities.pageTitle')}</Typography>
      </div>
      <Query query={fetchChainShiftResponsibilities} fetchPolicy='network-only'>
        {({ loading, error, data }) => (
          <Loader
            {...{
              loading,
              error,
            }}
          >
            <ShiftResponsibilityPage data={get(data, 'chainShiftResponsibilities', [])} />
          </Loader>
        )}
      </Query>
    </div>
  )
}

export default ChainShiftResponsibilityPage
